import {
    CREATE_INITIAL_STATE,
    GET_DEVICE_FAILED,
    GET_DEVICE_SUCCESS,
    SET_DEFAULT_STATE,
    SHOW_LOADING,
    TOGGLE_HARDWARE_ONLY,
    TRIGGER_GIGAKOMBI_OVERLAY,
    TOGGLE_INSURANCE,
    TOGGLE_TRADE_IN,
    TRIGGER_TRADE_IN_TRACKING,
    GO_TO_BASKET,
    HANDLE_PAGESHOW,
} from './constants';

/**
 * Fire when API request success
 * @param payload
 */
export function showLoading () {
    return {
        type: SHOW_LOADING,
    };
}

/**
 * Fire when API request success
 * @param payload
 */
export function getDeviceSuccess (payload) {
    return {
        type: GET_DEVICE_SUCCESS,
        payload,
    };
}

/**
 * Fire when API request fails
 * @param error
 */
export function getDeviceFailed (error) {
    return {
        type: GET_DEVICE_FAILED,
        error,
    };
}

/**
 * Fire when user enters or leaves hardware flow
 * @param
 */
export function toggleHardwareOnly () {
    return {
        type: TOGGLE_HARDWARE_ONLY,
    };
}

/**
 * createInitialState
 */
export function createInitialState (actions) {
    return {
        type: CREATE_INITIAL_STATE,
        actions,
    };
}

/**
 * createInitialState
 */
export function triggerGigaKombiOverlay () {
    return {
        type: TRIGGER_GIGAKOMBI_OVERLAY,
    };
}

/**
 * Set default state
 * @param isHardwareOnly
 * @param insurance
 * @param isTradeIn
 */
export function setDefaultState (isHardwareOnly, insurance, isTradeIn, isTauschbonus) {
    return {
        type: SET_DEFAULT_STATE,
        isHardwareOnly,
        insurance,
        isTradeIn,
        isTauschbonus,
    };
}

/**
 * Fire when user select/deselect device insurance
 * @param isChecked
 * @param trackIt
 * @param forceRerender
 */
export function toggleInsurance (isChecked: boolean, trackIt = false, forceRerender = true) {

    return {
        type: TOGGLE_INSURANCE,
        isChecked,
        trackIt,
        forceRerender,
    };
}

/**
 * Toggle trade in
 */
export function toggleTradeIn (force?: boolean) {
    return {
        type: TOGGLE_TRADE_IN,
        force,
    };
}

/**
 * Trigger trade in switch option tracking
 */
export function triggerTradeInTracking () {
    return {
        type: TRIGGER_TRADE_IN_TRACKING,
    };
}

/**
 * Go To Basket
 */
export function goToBasket () {
    return {
        type: GO_TO_BASKET,
    };
}

/**
 * Handle pageshow event
 */
export function handlePageShow (event: PageTransitionEvent) {
    return {
        type: HANDLE_PAGESHOW,
        event,
    };
}
